module.exports = __webpack_public_path__ + "img/om.0d6ffcbb.png";